import React, { forwardRef, useImperativeHandle, useState } from "react";
import "./style.scss";
const NestedImageSwiperSlide = ({ slides, contentWidth, onChange }) => {
  const [activeSlide, setActiveSlide] = useState(slides.length > 0 ? slides[0] : null);
  const onActiveSlideChange = slide => {
    setActiveSlide(slide);
    onChange && onChange(slide);
  };
  return (
    <div className="s-nested-image-swiper-slide">
      {activeSlide && (
        <div className="active-slide">
          <div className="active-slide__image" style={{ backgroundImage: `url(${activeSlide.fields.image.value?.src})`, height: (contentWidth * 9) / 16 + "px" }} />
        </div>
      )}
      <div className="nested-images">
        {slides.map((slide, j) => (
          <div className="nested-image" key={j} style={{ backgroundImage: `url(${slide.fields.thumbnail.value?.src ?? slide.fields.image.value?.src})`, height: (contentWidth - 40) / 3 + "px" }} onClick={e => onActiveSlideChange(slide)} />
        ))}
      </div>
    </div>
  );
};
export default NestedImageSwiperSlide;
